import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { useState } from 'react';

interface PanelSectionProps {
    title: string;
    children: React.ReactNode;
}

export const PanelSection = ({ title, children }: PanelSectionProps) => {
    const [expanded, setExpanded] = useState(true);
    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            sx={(theme) => ({
                width: '100%',
                border: `1px solid ${theme.palette.primary[500]}`,
                borderRadius: '0.5rem !important',
                margin: '0 !important',
                '& .MuiAccordionSummary-root': {
                    backgroundColor: theme.palette.primary[300],
                    padding: '0.5rem',
                    borderRadius: expanded ? '0.5rem 0.5rem 0 0' : '0.5rem',
                    minHeight: 'fit-content !important'
                },
                '& .MuiAccordionSummary-content': {
                    margin: '0 !important'
                },
                '& .MuiAccordionSummary-root .MuiTypography-root': {
                    color: theme.palette.primary[800],
                    fontSize: '1rem',
                    fontWeight: 500
                },
                '& .MuiAccordionDetails-root': {
                    padding: '0',
                    py: '0.5rem'
                }
            })}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>{title?.charAt(0)?.toUpperCase() + title?.slice(1)}</Typography>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
};
